export default "__VITE_ASSET__Cy3GciQV__"